export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./BoxSearch.vue?vue&type=template&id=775927e5&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/Settings/BoxSearch.vue?vue&type=template&id=775927e5&scoped=true&
// module id = 931
// module chunks = 0